import { MutationTree } from 'vuex';
import { IHttpState } from '@/store/modules/http/state';
import { MutationTypes } from './mutation-types';

export default {
  [MutationTypes.SET_IS_LOADING](state: IHttpState, isLoading: boolean) {
    state.isLoading = isLoading;
  },
} as MutationTree<any>;
